<div class="card">
  <div class="card-header">
    <h4>Exchange Rates</h4>
  </div>
  <div class="card-body m-0">
    <!-- <div class="row mb-2">
      <div class="col-xl-10 d-flex">
           
    
      </div>
    </div>
    <br> -->
    <div class="row mb-2">
      <div class="col-xl-12">
        <div class="text-start">
          <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()"><i class="feather icon-download me-2"></i>Export Excel</button>
          <button type="button" class="btn bg-danger-custom" (click)="quickFilterShowAction($event)"><i class="feather icon-filter me-2"></i>Quick Filters</button>
          <div class="btn-group mb-1 mb-md-0">
            <!--      <button type="button" class="btn bg-danger-custom">Columns</button>-->
            <div class="btn-group" ngbDropdown role="group">
              <button class="btn bg-danger-custom" ngbDropdownToggle><i class="feather icon-columns me-2"></i>Columns</button>
            <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
              style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
              <div class="form-group">
                <!--            <label for="columns" class="form-label"> All Columns</label>-->
                <div *ngIf="columnDefs" class="list-group ng-option">
                  <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox" >
                    <label class="list-group-item p-2">
                      <input class="form-check-input me-1" type="checkbox" style="margin-left: 180px;" value="{{i}}" name="{{column.headerName}}"
                        (change)="updateSelectedColumn($event)"
                        [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                      {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                    </label>
                  </span>
                </div>

              </div>
              <!--          <ng-select-->
              <!--            [(ngModel)]="tableSelectedColumn"-->
              <!--            [closeOnSelect]="false"-->
              <!--            [items]="columnDefs"-->
              <!--            [multiple]=true-->
              <!--            bindLabel="field">-->
              <!--            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>-->
              <!--              <input [ngModel]="item$.selected" id="item-{{index}}" type="checkbox"/> {{item.field.toUpperCase()}}-->
              <!--            </ng-template>-->
              <!--          </ng-select>-->

              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="col-xl-2" *ngIf="permissions.includes('View')">
        <input id="typeahead-basic" type="text" autocomplete="new-password" placeholder="Search in page"
          class="form-control" (selectItem)="searchQuickFilter($event)" [(ngModel)]="globalSearch"
          (ngModelChange)="onGlobalSearchChange($event)" [ngbTypeahead]="search" />
      </div> -->
    </div>

    <div *ngIf="quickFilterShow" class="row my-2" style="min-height: 100px">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="form-group col-md-4">
              <label class="col-form-label" for="fullName">Country</label>
              <ng-select #filStatus [items]="countryDropDown" bindLabel="countryName" bindValue="countryCode" [(ngModel)]="countrySelected" placeholder="Select Country">
                <ng-option disabled selected value="">Select Country</ng-option>
              </ng-select>
            </div>
            <div class="col-sm-4 d-flex align-items-end">
                <button (click)="onSearchBtnClick($event)" class="btn bg-danger-custom me-2" type="button" style="width: 100%;">
                <i class="feather icon-search me-2"></i>Search
              </button>
              <button (click)="resetFilter()" class="btn btn-secondary" type="button" style="width: 100%;">
                <i class="feather icon-refresh-cw me-2"></i>Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-0" style="min-height: 470px">
      <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
        <ag-grid-angular [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
          (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)" [gridOptions]="gridOptions"
          (filterOpened)="onFilterOpened($event)" (gridReady)="onGridReady($event)" (rowClicked)="onRowClicked($event)"
         (search)="globalSearch" [columnDefs]="tableSelectedColumn"
          [defaultColDef]="defaultColDef" [enableCellTextSelection]=true [paginationPageSize]="pageSize"
          [pagination]="true" [rowData]="rowData" [rowModelType]="" [rowSelection]="'single'"
          [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
        </ag-grid-angular>
      </div>
    </div>
    <div class="row mt-0">
      <div class="col-4 col-xs-4 d-flex">
        <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <!--          <option [ngValue]="10">10</option>-->
          <!--          <option [ngValue]="20">20</option>-->
          <!--          <option [ngValue]="30">30</option>-->
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
        </select>
        <p class="text-muted p-3"> Total Records: {{ collectionSize }}</p>
      </div>

      <div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
          [collectionSize]="collectionSize" [maxSize]="5" [pageSize]="pageSize" [rotate]="false" [directionLinks]="true"
          [ellipses]="false" size="sm" class="d-flex justify-content-end align-right">
        </ngb-pagination>
      </div>

    </div>
  </div>

</div>

<ng-template #audittrailModal let-modal>
  <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Audit Trail</h4>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body">
    <ngb-accordion >
      <ngb-panel *ngFor="let auditInfo of auditData; let i=index">
        <ng-template ngbPanelTitle>
          {{auditInfo.eventTimestamp}} &nbsp;&nbsp; <span [ngClass]="auditInfo.operation=='CREATE' ? 'badge-success' : auditInfo.operation=='UPDATE' ? 'badge-warning' : 'badge-danger' "class="badge badge-secondary">{{auditInfo.operation}}</span> 
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="row d-flex" *ngIf="auditInfo.before">
            <h5>Before</h5>
            <div class="form-group col-md-12 ">
                <div class="row mb-0" style="min-height: 170px">
                    <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                      <ag-grid-angular [enableCellTextSelection]=true 
                        [columnDefs]="tableSelectedAudit" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                         [rowData]="[auditInfo.before]" [rowModelType]="" [rowSelection]="'single'" [id]="'audittable.'+i"
                        [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                      </ag-grid-angular>
                    </div>
                  </div>
            </div>
        </div>
        <div class="row d-flex" *ngIf="auditInfo.after">
          <h5>After</h5>
          <div class="form-group col-md-12 ">
              <div class="row mb-0" style="min-height: 170px">
                  <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
                    <ag-grid-angular [enableCellTextSelection]=true 
                      [columnDefs]="tableSelectedAudit" [defaultColDef]="defaultColDef" [enableCellTextSelection]=true
                       [rowData]="[auditInfo.after]" [rowSelection]="'single'"
                      [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
                    </ag-grid-angular>
                  </div>
                </div>
          </div>
      </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
    <div class="row d-flex" *ngIf="auditData.length == 0">
      <h5 class="text-center">No Audit Data Found for {{selectedCountryName}} Country</h5>
      <br>
    </div>
    <div class="row mt-2">
      <div class="col-4 col-xs-4">
        <select (change)="onPageSizeChangesAudit($event)" [(ngModel)]="pageSizeAudit"
          class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
          <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>

        </select>
      </div>

      <div class="col-8 col-xs-8">
        <ngb-pagination (pageChange)="onPaginationChangeAudit($event)" [(page)]="currentPageAudit" [boundaryLinks]="true"
          [collectionSize]="collectionSizeAudit" [maxSize]="maxSize" [pageSize]="pageSizeAudit" [rotate]="true"
          [ellipses]="ellipses" size="sm" class="d-flex justify-content-end align-right">
        </ngb-pagination>
      </div>
    </div>

  </div>
  <div class="modal-footer justify-content-center">
      <button type="button" class="btn btn-danger" (click)="modal.close('Cancel')">Close</button>
  </div>
</ng-template>
